import React from 'react';
import DatePicker from './ui/DatePicker';
import PhotoAssistForm from './toolsRequest/PhotoAssistForm';
import KaoLaboForm from './toolsRequest/KaoLaboForm';
import AssistForm from './toolsRequest/AssistForm';
import ArForm from './toolsRequest/ArRequestForm';
import QrForm from './toolsRequest/QrRequestForm';
import API from '../lib/API';
import './ToolsRequestFormDialog.css';
import Loader from './ui/Loader';

class ToolsRequestFormDialog extends React.Component {
  state = {
    loading:false,
    loading_text: 'Loading',

    progress: 'form',
    isValid:false,

    okButtonTitle:'OK',
  }

  openDatePicker = (target, onChange) => {
    this.datePicker.open(target, onChange);
  }

  handleClickOKBtn = e => {
    e.preventDefault();
    switch (this.state.progress) {
      case 'form': this.setState({progress:'confirm', okButtonTitle:'申請'}); break;
      case 'confirm': this.doRequest(); break;
      default: this.setState({progress:'form', okButtonTitle:'OK'}); break;
    }
  }
  handleClickBackBtn = e => {
    e.preventDefault();
    switch (this.state.progress) {
      case 'confirm': this.setState({progress:'form', okButtonTitle:'OK'}); break;
      default: this.setState({progress:'form', okButtonTitle:'OK'}); break;
    }
  }

  handleFormValidation = isValid => {
    this.setState({
      isValid: isValid
    });
  }

  doLoading = loadingText => {
    this.setState({
      loading: !!loadingText,
      loading_text: loadingText
    });
  }

  doRequest = () => {
    this.setState({
      loading: true,
      loading_text: '申請中'
    });

    let data = this.form.getData();
    API.requestDocument(
      data.schoolCode,
      {
      type: this.props.type,
      props: {
        code: data.schoolCode,
        hinmei: data.hinmei,
        filename: data.filename
      },
      data:data.form
    }).then(ret=>{
      this.props.reloadAlbum();
      this.props.close();
    });
  }

  renderForm() {
    switch (this.props.type) {
      case 'photoAssist': 
        return <PhotoAssistForm ref={ref=>{this.form=ref}} data={this.props.data} progress={this.state.progress} 
          openDatePicker={this.openDatePicker} changeValidate={this.handleFormValidation} doLoading={this.doLoading}></PhotoAssistForm>;
      case 'kaolaboAlbum': 
        return <KaoLaboForm ref={ref=>{this.form=ref}} data={this.props.data} progress={this.state.progress} 
          openDatePicker={this.openDatePicker} changeValidate={this.handleFormValidation} doLoading={this.doLoading}></KaoLaboForm>;
      case 'assist': 
      case 'assist_v2': 
        return <AssistForm ref={ref=>{this.form=ref}} data={this.props.data} progress={this.state.progress} 
          openDatePicker={this.openDatePicker} changeValidate={this.handleFormValidation} doLoading={this.doLoading}></AssistForm>;
      case 'arRequest': 
        return <ArForm ref={ref=>{this.form=ref}} data={this.props.data} progress={this.state.progress} 
          openDatePicker={this.openDatePicker} changeValidate={this.handleFormValidation} doLoading={this.doLoading}></ArForm>;
      case 'qrRequest': 
      case 'qrRequest_v2': 
        return <QrForm ref={ref=>{this.form=ref}} data={this.props.data} progress={this.state.progress} 
          openDatePicker={this.openDatePicker} changeValidate={this.handleFormValidation} doLoading={this.doLoading}></QrForm>;
      default:return null;
    }
  }
  render() {
    return (<div className="ToolsRequestFormDialog dialog" data-type={this.props.type}>
      <div className="dialog-window">
        <div className="dialog-main">
          {this.renderForm()}
        </div>
        <div className="dialog-buttons">
          <button className="dialog-button cancelBtn" onClick={this.props.close}>キャンセル</button>
          {
            this.state.progress === 'form' ? null
            :  <button className="dialog-button backBtn" onClick={this.handleClickBackBtn}>戻る</button>
          }
          <button className="dialog-button okBtn" onClick={this.handleClickOKBtn} disabled={!this.state.isValid}>{this.state.okButtonTitle}</button>
        </div>
      </div>

      <DatePicker ref={ref=>{this.datePicker=ref}}/>
      <Loader active={this.state.loading} text={this.state.loading_text}/>
    </div>)
  }
}
export default ToolsRequestFormDialog;